import i18n from 'i18next';
import { createKey } from './helpers';

export interface TranslationObject {
    value: string;
    _context?: string;
}

// translation function
export function __(
    translationKey: string,
    interpolationMap?: Record<string, unknown> | undefined
): string {
    const context =
        interpolationMap && '_context' in interpolationMap
            ? String(interpolationMap._context)
            : undefined;

    const updatedKey = createKey(translationKey, context);
    const translation = i18n.t(updatedKey, interpolationMap);

    if (translation && typeof translation === 'object' && 'value' in translation) {
        return (translation as TranslationObject).value;
    }

    if (updatedKey !== translation) {
        return translation;
    }

    return i18n.t(translationKey, interpolationMap);
}
